/**
 * Mobile Menu
 */
const MobileMenu = () => {
  const navToggle = document.querySelector(".header-mobile-menu-toggle");
  const nav = document.querySelector(".nav--main-mobile");
  const overlay = document.querySelector(".mobile-nav-overlay");
  const heroOverlay = document.querySelector(".hero-image-overlay");
  const main = document.querySelector("main");
  const navClose = document.querySelectorAll(
    ".header-mobile-menu-toggle--close"
  );
  const childToggle = document.querySelectorAll(
    ".mobile-nav-item-children-toggle"
  );
  const childBackToggle = document.querySelectorAll(".mobile-nav-item-back");
  const accordionBtn = document.querySelectorAll(".toggle-accordion");
  const accordionButtons = [].slice.call(accordionBtn);
  const body = document.querySelector("body");
  /**
   * Toggle Main nav
   */
  const toggleNav = () => {
    nav.classList.toggle("open");
    overlay.classList.add("overlay-active");
    if (heroOverlay) {
      heroOverlay.classList.add("overlay-active");
      heroOverlay.classList.add("overlay-index");
    }
    body.classList.add("nav-active");

    accordionButtons.forEach(e => {
      e.classList.add("accordion-overlay");
    });
  };

  /*
   * Close all child navs
   */
  const closeAllNavs = () => {
    const openNavs = nav.querySelectorAll(".open");

    openNavs.forEach(el => {
      el.classList.remove("open");
    });
  };

  /**
   * Open child nav
   * @param DOMNode el
   */
  const openNav = el => {
    const childNav = el.parentNode.querySelector(".mobile-nav-item--children");
    childNav.classList.add("open");
    el.setAttribute("aria-expanded", "true");
  };

  /**
   * Close the main nav
   */
  const closeNav = () => {
    nav.classList.remove("open");
    overlay.classList.remove("overlay-active");
    if (heroOverlay) {
      heroOverlay.classList.remove("overlay-active");
    }
    body.classList.remove("nav-active");

    setTimeout(() => {
      if (heroOverlay) {
        heroOverlay.classList.remove("overlay-index");
      }

      accordionButtons.forEach(e => {
        e.classList.remove("accordion-overlay");
      });
    }, 300);

    closeAllNavs();
  };

  /**
   * Close current child nav and go back up one level
   * @param DOMNode el
   */
  const goBack = el => {
    const parentContainer = el.parentNode.parentNode;
    parentContainer.classList.add("close");
    // parentContainer.classList.remove("open");
  };

  /**
   * Bind event handlers
   */
  const bindEventHandlers = () => {
    navToggle.addEventListener("click", toggleNav);

    const closeContainer = [].slice.call(navClose);

    closeContainer.forEach(el => {
      el.addEventListener("click", closeNav);
    });

    main.addEventListener("click", () => {
      if (
        (overlay && overlay.classList.contains("overlay-active")) ||
        (heroOverlay && heroOverlay.classList.contains("overlay-active"))
      ) {
        closeNav();
      }
    });

    const toggleContainer = [].slice.call(childToggle);

    toggleContainer.forEach(el => {
      el.addEventListener("click", () => openNav(el));
    });

    const backContainer = [].slice.call(childBackToggle);

    backContainer.forEach(el => {
      el.addEventListener("click", () => goBack(el));
    });
  };

  bindEventHandlers();
};

export default MobileMenu;
